/**
 * Created by dmitry on 23.10.2026
 */

MinimalDialogue.prototype.createPerson = cleverapps.extendFunc(MinimalDialogue.prototype.createPerson, function () {
    if (!this.options.noPerson) {
        return this._super();
    }

    const personNode = new cc.Node();
    personNode.setAnchorPoint(0.5, 0.5);
    return personNode;
});

MinimalDialogue.prototype.createContent = cleverapps.extendFunc(MinimalDialogue.prototype.createContent, function (maxDimensions) {
    if (!this.options.noPerson) {
        this._super(maxDimensions);
        return;
    }

    const styles = cleverapps.styles.MinimalDialogue.person;
    const { margin } = styles;
    styles.margin = 0;
    this._super(maxDimensions);
    styles.margin = margin;

    if (this.textBgArrow) {
        this.textBgArrow.setVisible(false);
    }
});
